module.exports = __webpack_public_path__ + "static/img/y25-4.62c29e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y25-4.png
// module id = aWf2
// module chunks = 1